<template>
  <div id="deposit_pages" class="clearfix mg_bot50">
    <base-deposit-withdraw-history />
  </div>
</template>

<script>
  import BaseDepositWithdrawHistory from './BaseDepositWithdrawHistory';

  export default {
    components: {
      BaseDepositWithdrawHistory,
    },
    data() {
      return {
        titlePage: 'Deposit',
      }
    },
    created() {
      this.$emit('EVENT_PAGE_CHANGE', this);
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";
</style>
